import { render, staticRenderFns } from "./PreviewImg.vue?vue&type=template&id=16d4c4c0&scoped=true"
import script from "./PreviewImg.vue?vue&type=script&lang=js"
export * from "./PreviewImg.vue?vue&type=script&lang=js"
import style0 from "./PreviewImg.vue?vue&type=style&index=0&id=16d4c4c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d4c4c0",
  null
  
)

export default component.exports